module.exports = __webpack_public_path__ + "static/logo-add-8f72894dc6e2edbfb9617abc9fb70eb4.png";